import { useEffect } from 'react';
import {
  type ExtensionBridge,
  AppTokenCapability,
} from '@doxyme/extensions-bridge';
import {
  useAddCapability,
  useRegistrySingleton,
} from '@doxyme/extensions-bridge-react';
import { _getLogger } from '@doxyme/analytics';

/**
 * Hook responsible for triggering registry api to retrieve app token for the given appId
 */

export function useExtensionsAppToken(bridge: ExtensionBridge): void {
  const appToken = useAddCapability(bridge, () => new AppTokenCapability());
  const registry = useRegistrySingleton();

  useEffect(() => {
    const unsubscribeFromGet = appToken.onGet(
      async (manifestName: string): Promise<string> => {
        const app = registry.apps.find(
          (app) => app.manifest.name === manifestName,
        );
        if (!app) {
          throw new Error(`App with manifest name ${manifestName} not found`);
        }

        return registry.generateAppToken(app.id);
      },
    );
    return () => {
      unsubscribeFromGet();
    };
  }, [registry.apps]);
}
